module.exports = __webpack_public_path__ + "img/235.4599ddf5.jpg";